import toiletMgt from './ToiletMgt'
import violation from './violation'
import StayAverage from './StayAverage'

export default {
	state: {
	},
	modules: {
		toiletMgt,
		violation,
		StayAverage
	},
}